export default __webpack_public_path__ + "static/media/background.0ca91ae3.svg";